/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentStageList = {
    type: 'array',
    contains: {
        type: 'TournamentStage',
    },
} as const;
